import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';

import { TermsAndConditions } from '@modules/terms/TermsAndConditions';

const TITLE = 'Qeeper - Terms and Conditions';
const DESC = 'Qeeper terms and conditions.';
const URL = 'https://www.qeeper.co.uk/terms-and-conditions';

const SEO_KEYWORDS = 'Qeeper terms and conditions';

const TermsAndConditionsPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <TermsAndConditions />
    </>
  );
};

export default TermsAndConditionsPage;
